import * as React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import CPGuestLandingLayout from "../../shared/components/app/CPGuestLandingLayout/CPGuestLandingLayout";

import LoginPage from "./LoginPage/LoginPage";
import RequestAccessPage from "./RequestAccessPage/RequestAccessPage";
import ShortCodePage from "./ShortCodePage/ShortCodePage";
import SsoRegisterPage from "./SsoRegisterPage/SsoRegisterPage";
import InvitePage from "./InvitePage/InvitePage";
import CPAppLoader from "../../shared/components/shared/CPAppLoader/CPAppLoader";

import useAppStore from "../../shared/state/useAppState";
import ErrorPage from "routes/public/ErrorPage/ErrorPage";
import { useSiteStatusQuery, isSiteStatusActive } from "data/app/app";

const PublicRoutes: React.FC = () => {
  const isLoading = useAppStore((app) => app.isLoading);
  const { data: siteStatus } = useSiteStatusQuery();

  if (isLoading) {
    return <CPAppLoader isLoading={true} text="Evans Business Intelligence" />;
  }

  return (
    <Routes>
      <Route
        path="/"
        element={<CPGuestLandingLayout />}
        errorElement={<ErrorPage />}
      >
        <Route element={<LoginPage />} index />

        <Route
          path="request-access"
          element={isSiteStatusActive(siteStatus) ? <Navigate to="/" replace /> : <RequestAccessPage />}
        />

        <Route
          path="sso-register"
          element={isSiteStatusActive(siteStatus) ? <Navigate to="/" replace /> : <SsoRegisterPage />}
        />

        <Route
          path="verify-code"
          element={isSiteStatusActive(siteStatus) ? <Navigate to="/" replace /> : <ShortCodePage />}
        />

        <Route path="invite/:code" element={<InvitePage />} />

        <Route path="Error" element={<ErrorPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};
export default PublicRoutes;
